import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
} from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TemplateContext } from './model/template-context.interface';
import { TemplateService } from './template.service';

import { ISPFieldType } from '../../model';
import { ISPFieldTypeBase } from '../field-type-base.class';

@Component({
  selector: 'isp-template-field',
  templateUrl: './template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateFieldComponent
  extends ISPFieldTypeBase<ISPFieldType.Template>
  implements OnInit
{
  template$: Observable<TemplateRef<TemplateContext>>;

  constructor(private readonly templateService: TemplateService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.template$ = this.templateService
      .getTemplateByName$(this.props.templateName)
      // @WARN i.ablov don't know why, but this check required in extform footer buttons case
      .pipe(tap(() => setTimeout(() => this.cdr.markForCheck())));
  }
}
